var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"7.41","viewBox":"0 0 12 7.41"}},[_c('g',{attrs:{"transform":"translate(12) rotate(90)"}},[_c('path',{staticClass:"a",attrs:{"d":"M1.41,0,0,1.41,4.58,6,0,10.59,1.41,12l6-6Z"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }